import {
  Button, Dialog, DialogContent, DialogTitle,
  Grid, Typography, Box
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

type ScrollDialogReporteProps = {
  title: string;
  subtitulo: string;
  isOpen: boolean;
  setIsOpenModal: (open: boolean) => void;
  icon?: React.ReactNode;         // Icono opcional
  buttonText?: string;            // Texto del botón opcional
};

export default function ScrollDialogReporte({
  isOpen,
  setIsOpenModal,
  title,
  subtitulo,
  icon = <CheckCircleIcon sx={{ fontSize: 80, color: "success.main" }} />,
  buttonText = "Aceptar"
}: ScrollDialogReporteProps) {
  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpenModal(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
        {title}
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center" }}>

        {/* Ícono animado */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1,}}>
          <Box sx={{ animation: "pop 0.3s ease-out" }}>
            {icon}
          </Box>
        </Box>

        {/* Subtítulo */}
        <Typography
          sx={{
            fontSize: 16, mb: 3,
            color: "text.secondary",
            lineHeight: 1.5,
            fontWeight: 'bold',
            gap: 1
          }}
        >
          {subtitulo}
        </Typography>

        {/* Botón */}
        <Grid container justifyContent={"center"}>
          <Button variant="contained" onClick={() => setIsOpenModal(false)}>
            {buttonText}
          </Button>
        </Grid>
      </DialogContent>

      {/* Animación */}
      <style>
        {`
          @keyframes pop {
            0% { transform: scale(0.5); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }
        `}
      </style>
    </Dialog>
  );
}
